export default {
  setIsLoggedIn(state, value) {
    state.isLoggedIn = value;
  },
  setErrors(state, value) {
    state.errors = value;
  },
  setUser(state, value) {
    if (!value.Tags) {
      value.Tags = "";
    }
    state.user = value;
  },
  setErrorMessage(state, value) {
    state.errorMessage = value;
  },
  setShowErrorMessage(state, value) {
    state.showErrorMessage = value;
  },
  incrementLoadingCount(state) {
    state.loadingCount++;
  },
  decrementLoadingCount(state) {
    if (state.loadingCount > 0) {
      state.loadingCount--;
    }
  },
  setShowLoading(state, value) {
    state.showLoading = value;
  },
  setMaxLoadingDuration(state, value) {
    state.maxLoadingDuration = value;
  },
  resetMaxLoadingDuration(state) {
    state.maxLoadingDuration = 20 * 1000;
  },
  setShowOrthodonticsModal(state, value) {
    state.showOrthodonticsModal = value;
  },
  setOpenMenu(state, value) {
    state.openMenu = value;
  },
  setCloseMenu(state, value) {
    state.closeMenu = { value: value, keepModal: false };
  },
  setCloseMenuKeepModal(state, value) {
    state.closeMenu = { value: value, keepModal: value };
  },
  setShowPolicyNumber(state, value) {
    state.showPolicyNumber = value;
  },
  setIsScrolledTop(state, value) {
    state.isScrolledTop = value;
  },
  setPainarea(state, value) {
    state.painarea = value;
  },
  setPainareaSelectedMapHistory(state, value) {
    state.painareaSelectedMapHistory = value;
  },
  setSpreadarea(state, value) {
    state.spreadarea = value;
  },
  setRoodieChecks(state, value) {
    state.roodieChecks = value;
  },
  setIsImageMapChanged(state, value) {
    state.isImageMapChanged = value;
  },
  setResetHomeView(state, value) {
    state.resetHomeView = { value: value, force: false };
  },
  setResetHomeViewForce(state, value) {
    state.resetHomeView = { value: value, force: value };
  },
  setRouteAfterLogin(state, value) {
    state.routeAfterLogin = value;
  },
  setFiles(state, value) {
    state.files = value;
  },
  setCases(state, value) {
    state.cases = value;
  },
  setConversations(state, value) {
    state.conversations = value;
  },
  setDoctors(state, value) {
    state.doctors = value;
  },
};
